import React from 'react';

import PharmacyList from '../component-list-pharmacies';
import Suspense from '../../Common/components/Suspense-component';

export class PharmacyContainer extends React.Component {

    render() {
        return (
            <Suspense>
                <PharmacyList />
            </Suspense>
        );
    }
}



// WEBPACK FOOTER //
// ./src/customModules/Pharmacies/containers/container-list-pharmacies.js